var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1ydof4uzaa",
    d: "M37.843 0C58.71 0 75.686 17.104 75.686 38.128c0 7.247-1.957 14.937-5.819 22.855-3.055 6.266-7.306 12.694-12.635 19.106-9.04 10.879-17.942 17.863-18.317 18.155-.315.246-.694.369-1.072.369-.378 0-.756-.123-1.072-.37-.375-.291-9.277-7.275-18.317-18.154-5.329-6.412-9.58-12.84-12.635-19.106C1.958 53.065 0 45.375 0 38.128 0 17.104 16.976 0 37.843 0zm0 23.625c-7.95 0-14.395 6.493-14.395 14.503S29.893 52.63 37.843 52.63c7.95 0 14.395-6.494 14.395-14.503 0-8.01-6.445-14.503-14.395-14.503z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDA",
    d: "M34.815 74.57l-.016.038h10.909l-.045-.039h55.143c.22 0 .434.042.632.12.487.152.893.515 1.096 1.006l17.292 41.861c.225.545.166 1.168-.16 1.658-.324.49-.872.786-1.457.786H1.752c-.585 0-1.132-.295-1.457-.786-.326-.49-.386-1.113-.16-1.658l11.219-27.16h-.127l6.09-14.74c.27-.658.91-1.087 1.617-1.087h15.88z",
    transform: "translate(-40 -40) translate(40.02 40)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4CE166",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.185 15.063L97.516 15.865 97.516 15.865z",
    transform: "translate(-40 -40) translate(40.02 40) translate(10.996 74.531)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F7F5",
    d: "M113.086 101.468L107.768 88.594 61.746 88.594 45.663 74.569 34.874 74.569 33.501 74.569 27.679 88.591 11.973 88.591 8.446 97.13 6.654 101.468 22.376 101.468 14.737 119.961 29.029 119.961 41.299 89.92 76.682 119.961 97.571 119.961 76.425 101.468z",
    transform: "translate(-40 -40) translate(40.02 40)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -40) translate(40.02 40) translate(22.027)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3FAE29",
    fillRule: "nonzero",
    xlinkHref: "#1ydof4uzaa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bf6d9dce58cddb3e56b4ab72a0b83ccb.svg";
export { ForwardRef as ReactComponent };